import type { ColDef } from 'ag-grid-community';

/**
 * Column definitions for SFTP tenant config grid
 */
const sftpTenantConfigColDef = (): ColDef[] => {
  const colDef: ColDef[] = [
    {
      headerName: 'Tenant ID',
      field: 'tenantId',
      width: 150,
      filter: 'agTextColumnFilter',
      sortable: true,
    },
    {
      headerName: 'Config Name',
      field: 'configName',
      width: 250,
      filter: 'agTextColumnFilter',
      sortable: true,
    },
    {
      headerName: 'Pod ID',
      field: 'podId',
      width: 150,
      filter: 'agTextColumnFilter',
      sortable: true,
    },
    {
      headerName: 'Enabled',
      field: 'enabled',
      width: 100,
      filter: 'agSetColumnFilter',
      filterParams: {
        values: [true, false],
      },
      cellRenderer: (params: any) => {
        const enabled = params.value;
        return enabled ? 'Yes' : 'No';
      },
      cellStyle: (params: any) => {
        const enabled = params.value;
        return {
          color: enabled ? '#4caf50' : '#f44336',
          fontWeight: '500',
        };
      },
    },
    {
      headerName: 'Destinations',
      field: 'destinationCount',
      width: 130,
      filter: 'agNumberColumnFilter',
      sortable: true,
      valueGetter: (params: any) => {
        const destinations = params.data?.destinations;
        if (!destinations || !Array.isArray(destinations)) return 0;
        return destinations.length;
      },
      cellRenderer: (params: any) => {
        const count = params.value;
        const destinations = params.data?.destinations;
        const activeCount = destinations?.filter((d: any) => d.isEnabled)?.length || 0;
        if (count === 0) return '0';
        return `${activeCount}/${count} active`;
      },
    },
    {
      headerName: 'Source Type',
      field: 'source.type',
      width: 120,
      filter: 'agSetColumnFilter',
      filterParams: {
        values: ['SFTP', 'FTP', 'FTPS'],
      },
      valueGetter: (params: any) => {
        return params.data?.source?.type || 'SFTP';
      },
    },
    {
      headerName: 'Source Endpoint',
      field: 'source.endpoint',
      width: 200,
      filter: 'agTextColumnFilter',
      valueGetter: (params: any) => {
        return params.data?.source?.endpoint || '';
      },
    },
  ];
  
  return colDef;
};

export default sftpTenantConfigColDef;